import { Flex, Pane, Text } from '@leverege/ui-elements'
import React from 'react'
import usePaceOverviewCards from '../hooks/usePaceOverviewCards'
import S from './PaceOverviewCards.css'
import { formatPaceTimes } from './Utils'

function PaceOverviewCards( { fgJob } ) {
  const { paces } = usePaceOverviewCards( fgJob )

  return (
    <div className={S.grid}>
      {paces.map( p => (
        <Pane variant="dashboardCardCustom" className={S.card}>
          <Pane variant="dashboardCardCustomHeader">
            <Flex variant="rowSpaceBetween" align="center">
              <Text variant="paceCardHeader" style={{ fontSize : '2em' }}>
                {p.title}
              </Text>
              {p.completed && <Text variant={`tag${p.status}`}>Completed</Text>}
            </Flex>
          </Pane>
          <Pane
            variant="dashboardCardCustomArea"
            className={S[`cardArea${p.status}`]}>
            <Flex gap={10}>
              <Flex
                variant="colM"
                style={{
                  justifyContent : 'center',
                  padding : '0 0 10px 0',
                  flexGrow : 1,
                }}>
                <Text variant="paceCardDetailHeader">CT</Text>
                <Text
                  variant={`pace${p.status}`}
                  style={{
                    flexGrow : 1,
                    minWidth : 122,
                    fontSize : '5em',
                  }}
                  iconOpts={{ fontSize : '5em' }}>
                  {p.currentPace}
                </Text>
              </Flex>
              <Flex variant="rowSpaceAround" gap={4}>
                <Pane variant="detailBox" className={S.detailBox}>
                  <Flex variant="colM">
                    <Text variant="paceCardDetailHeader">Target CT</Text>
                    <Text
                      variant="paceCardDetailContent"
                      style={{ fontSize : '3.2em' }}>
                      {p.targetPace}
                    </Text>
                  </Flex>
                </Pane>
                <Pane variant="detailBox" className={S.detailBox}>
                  <Flex variant="colM">
                    <Text variant="paceCardDetailHeader">CT Difference</Text>
                    <Text
                      variant="paceCardDetailContent"
                      className={S[`paceCardDetailContent${p.status}`]}
                      style={{ fontSize : '3.2em' }}>
                      {p.status === 'Idle' ?
                        '-' :
                        formatPaceTimes( p.currentPace - p.targetPace, {
                          signDisplay : 'always',
                        } )}
                    </Text>
                  </Flex>
                </Pane>
              </Flex>
            </Flex>
          </Pane>
        </Pane>
      ) )}
    </div>
  )
}

export default PaceOverviewCards
